module.exports = __webpack_public_path__ + "static/img/0tgimg.d501303.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/0tgimg.jpg
// module id = NoIT
// module chunks = 2